module.exports = "<!--\r\nAuto-generated\r\nDo not edit!!!\r\n-->\r\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// C:/Repositories/wfa3/SupplierPortal/app/src/app/modules/application/application.module.component.html
// module id = ../../../../../src/app/modules/application/application.module.component.html
// module chunks = main